import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { $ } from "react-jquery-plugin";

const BANNER_SRC = "/banner/Zillion-banner-gold-black.png";

/** Matches `id` on AirDrop “How To Join” / task section for auto-scroll from this banner. */
export const AIRDROP_TASKS_SECTION_HASH = "airdrop-tasks";

/** Banner shows again whenever the user navigates to this page (component remounts). Closing only hides it for the current visit. */
export default function AirdropPromoBannerModal({ modalId, enabled = true }) {
  const [closedThisVisit, setClosedThisVisit] = useState(false);

  useEffect(() => {
    if (!enabled || closedThisVisit) return;
    const el = document.getElementById(modalId);
    if (!el) return;
    const $el = $(el);
    $el.modal("show");
    const onHidden = () => {
      setClosedThisVisit(true);
      $el.off("hidden.bs.modal", onHidden);
    };
    $el.on("hidden.bs.modal", onHidden);
    return () => {
      $el.off("hidden.bs.modal", onHidden);
      try {
        $el.modal("hide");
      } catch {
        /* ignore */
      }
    };
  }, [enabled, closedThisVisit, modalId]);

  const dismissModal = () => {
    try {
      $(`#${modalId}`).modal("hide");
    } catch {
      /* ignore */
    }
  };

  const onBannerClick = () => {
    dismissModal();
  };

  if (closedThisVisit || !enabled) return null;

  return (
    <div
      className="modal fade search_form airdrop_promo_banner_modal"
      id={modalId}
      tabIndex="-1"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={dismissModal}
            />
          </div>
          <div className="modal-body">
            <Link to={`/airdrop#${AIRDROP_TASKS_SECTION_HASH}`} onClick={onBannerClick}>
              <img src={BANNER_SRC} alt="Zillion Airdrop" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
